import { render, staticRenderFns } from "./DniFieldBusinessV2.vue?vue&type=template&id=70b66fba&scoped=true&"
import script from "./DniFieldBusinessV2.vue?vue&type=script&lang=ts&"
export * from "./DniFieldBusinessV2.vue?vue&type=script&lang=ts&"
import style0 from "./DniFieldBusinessV2.vue?vue&type=style&index=0&id=70b66fba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b66fba",
  null
  
)

export default component.exports